import { TimeAwareCache } from '@bingads-webui-universal/time-aware-cache';
import { BaseCacheManager } from './base-cache-manager';

/**
 * @typedef {Object} ServerCacheKey
 * @property {string} resource - Resource name (entity type name)
 * @property {string} adapter - Adapter name
 */

export class ServerCacheManager extends BaseCacheManager {
  /**
   * Server side cache manager to store the server cache hints.
   */
  constructor() {
    super();

    // Server side cache manager has no partition, all cache hints are saved in
    // 1 TimeAwareCache with unlimited slots
    this.cache = new TimeAwareCache();

    // Delegate the notifications from the storage cache, so that the cacheIndex
    // can be updated accordingly
    this.cache.subscribe(this);
  }

  /**
   * Get the storage cache for the given cache key
   * @override
   * @param {ServerCacheManager} key - The cache key
   * @returns {TimeAwareCache} - The storage cache for the given key
   */
  storageCacheFor(/* key */) {
    return this.cache;
  }
}
